const MEMBER_SORT_KEYS = {
  NAME: 'name',
  GUARDIAN_NAME: 'guardian_name',
  FEE_AMOUNT: 'fee_amount',
  NEXT_DUE_AT: 'next_due_at',
  TOTAL_AMOUNT: 'total_amount',
  TOTAL_COLLECTED_AMOUNT: 'total_collected_amount',
  TOTAL_PENDING_AMOUNT: 'total_pending_amout'
} as const;

export default MEMBER_SORT_KEYS;
